import React from "react";

import {
	Backdrop,
	CircularProgress
} from "@mui/material";

export default class ZPlayLoader extends React.Component<{}, {}>
{

	render() {
		return (<Backdrop
			sx={{
				color: process.env.REACT_APP_PRIMARY_COLOR,
				zIndex: (theme) => theme.zIndex.drawer + 1
			}}
			open={true}>
			<CircularProgress color="inherit" size="8rem" />
		</Backdrop>);
	}
}
